import {
  UPDATE_VALUE_DISTRICT,
  UPDATE_VALUE_PROVINCE,
  UPDATE_VALUE_WARD,
} from 'constants/threeLevelLocation';

export interface LevelLocation {
  code: string;
  label: string;
  id: number;
}

export interface ThreeLevelLocation {
  province: LevelLocation;
  /** @deprecated */
  district?: LevelLocation;
  ward: LevelLocation;
}

export const initThreeLevelLocation: ThreeLevelLocation = {
  province: {
    code: '',
    label: '',
    id: 0,
  },
  district: {
    code: '',
    label: '',
    id: 0,
  },
  ward: {
    code: '',
    label: '',
    id: 0,
  },
};

export type TYPE_REDUCER =
  | 'UPDATE_VALUE_PROVINCE'
  | 'UPDATE_VALUE_DISTRICT'
  | 'UPDATE_VALUE_WARD';

export const threeLevelLocationReducer = (
  state: ThreeLevelLocation,
  action: {
    type: TYPE_REDUCER;
    value: LevelLocation;
  },
) => {
  switch (action.type) {
    case UPDATE_VALUE_PROVINCE:
      return {
        ...state,
        province: action.value,
      };
    case UPDATE_VALUE_DISTRICT:
      return {
        ...state,
        district: action.value,
      };
    case UPDATE_VALUE_WARD:
      return {
        ...state,
        ward: action.value,
      };
    default:
      return state;
  }
};
